import styled from 'styled-components';
import { spacing, zIndex, largeShadow, borderRadius } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const ConditionMultiValueWrapper = styled.div`
  width: ${pxToRem(300)};
  height: ${spacing.double};
  z-index: ${zIndex.newDropdown};
  position: relative;
`;

export const MultiSelectWrapper = styled.div`
  background-color: white;
  overflow-y: auto;
  max-height: ${pxToRem(353)};
  box-shadow: ${largeShadow.boxShadow};
  border-radius: ${borderRadius.lg};
  margin-top: ${spacing.quarter};
  z-index: ${zIndex.newDropdown};
  width: ${pxToRem(672)};
`;

export const MultiSelectWithoutDisplayValuesWrapper = styled(MultiSelectWrapper)`
  overflow-y: visible;
  max-height: none;
`;

export const ConditionMultiValueContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex: 1 1 min-content
`;

export const AdditionalCountOuterWrapper = styled.span`
  width: min-content;
  display: flex;
`;

export const AdditionalCountWrapper = styled.span`
  padding-left: ${spacing.quarter};
`;
